import MenuModel from './menuModel';

import { ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL } from '../utils/enums';
import { currentUserIsDeliveryManager, currentUserIsDepotRole } from '../services/userModel';
import { getCurrentDepotByBusiness } from '../services/restaurant';

export function createOrderingMenuMenuTemplate() {
    return [
        // new MenuModel({
        //     pathname: ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingBusinessParentMenu,
        //     title: "settings.orderingmenu.MENU_BUSINESS_PARENT_MENU",
        //     icon: "parentMenu",
        //     isShow: () => isShowParentBusinessMenu(),
        //     searchParams: state => {
        //         return `?id=${getCurrentDepotByBusiness(state)}`
        //     },
        //     active: location => getIsActive(location, ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingBusinessParentMenu)
        // }),
        new MenuModel({
            pathname: ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingBusinessMenu,
            title: "settings.orderingmenu.MENU_BUSINESS_MENU",
            icon: "childMenu",
            searchParams: state => {
                return `?id=${getCurrentDepotByBusiness(state)}`
            },
            active: location => getIsActive(location, ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingBusinessMenu) || getIsActive(location, ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingBusinessMenuExtras)
        }),
        new MenuModel({
            pathname: ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingMenuBusinesInfo,
            title: "settings.orderingmenu.MENU_BUSINESS_INFO",
            icon: "businessInfo",
            searchParams: state => {
                return `?id=${getCurrentDepotByBusiness(state)}`
            },
            active: location => getIsActive(location, ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingMenuBusinesInfo)
        }),
        new MenuModel({
            pathname: ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingMenuCategories,
            title: "settings.businessCategories.LABEL",
            titleInfo: "settings.businessCategories.LABEL",
            icon: "orderingBusinessCategories",
            isTitleInfoShow: function() {
                return currentUserIsDepotRole() && !currentUserIsDeliveryManager();
            },
            searchParams: state => {
                return `?id=${getCurrentDepotByBusiness(state)}`
            },
            active: location => getIsActive(location, ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingMenuCategories)
        }),
        new MenuModel({
            pathname: ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingMenuTranslations,
            title: 'settings.translations.LABEL',
            titleInfo: 'settings.translations.LABEL',
            icon: 'translations',
            isTitleInfoShow: function() {
                return currentUserIsDepotRole() && !currentUserIsDeliveryManager();
            },
            searchParams: state => {
                return `?id=${getCurrentDepotByBusiness(state)}`;
            },
            active: location => getIsActive(location, ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingMenuTranslations),
        }),
        // new MenuModel({
        //     pathname: ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingMenuSku,
        //     title: 'settings.sku_override.LABEL',
        //     titleInfo: 'settings.sku_override.LABEL',
        //     icon: 'sku',
        //     isTitleInfoShow: function() {
        //         return currentUserIsDepotRole() && !currentUserIsDeliveryManager();
        //     },
        //     searchParams: state => {
        //         return `?id=${getCurrentDepotByBusiness(state)}`;
        //     },
        //     active: location => getIsActive(location, ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingMenuSku),
        // }),
        new MenuModel({
            pathname: ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingMenuPrice,
            title: 'settings.price_override.LABEL',
            titleInfo: 'settings.price_override.LABEL',
            icon: 'woltW',
            isTitleInfoShow: function() {
                return currentUserIsDepotRole() && !currentUserIsDeliveryManager();
            },
            searchParams: state => {
                return `?id=${getCurrentDepotByBusiness(state)}`;
            },
            active: location => getIsActive(location, ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingMenuPrice),
        }),
        new MenuModel({
            pathname: ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingMenuData,
            title: 'settings.menu_data.LABEL',
            titleInfo: 'settings.menu_data.LABEL',
            icon: 'sku',
            isTitleInfoShow: function() {
                return currentUserIsDepotRole() && !currentUserIsDeliveryManager();
            },
            searchParams: state => {
                return `?id=${getCurrentDepotByBusiness(state)}`;
            },
            active: location => getIsActive(location, ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingMenuData),
        }),
        new MenuModel({
            pathname: ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingMenuLink,
            title: 'settings.deepLink.DEPOT_LABEL',
            icon: 'link',
            isTitleInfoShow: function() {
                return currentUserIsDepotRole() && !currentUserIsDeliveryManager();
            },
            searchParams: state => {
                return `?id=${getCurrentDepotByBusiness(state)}`;
            },
            active: location => getIsActive(location, ORDERING_MARKETPLACE_MENU_TYPE_SECTION_MODEL.orderingMenuLink),
        }),
    ];
}

function getIsActive(location, type) {
  const splitCurrentLocation = location.pathname.split("/");
  const splitType = type.split("/");
  return splitCurrentLocation[1] === splitType[1] &&
         splitCurrentLocation[2] === splitType[2] &&
         splitCurrentLocation[3] === splitType[3] &&
         splitCurrentLocation[4] === splitType[4]
}
